import { render } from "./July5th2022.vue?vue&type=template&id=72987db4&ts=true"
import script from "./July5th2022.vue?vue&type=script&lang=ts"
export * from "./July5th2022.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__